export default __webpack_public_path__ + "static/media/c-like-icon.3556387c.svg";